export const en = {
  configure: "Configure",
  your_vehicle: "your vehicle",
  our_models: "Our models",
  and_vehicles: "and vehicles",
  home: "Home",
  previous: "Previous",
  all_about_aixam: "All about Aixam",
  aixam_models: "Aixam models",
  changing_models: "Changing models",
  read_more: "Read more",
  discover_the_types_of_vehicles: "Discover the types of vehicles",
  type_of_vehicle: "Types of vehicle",
  back_to_aixam_model_presentation: "Back to Aixam model presentation",
  changing_vehicle_type: "Changing vehicle type",
  in_pictures: ({ plural, named }) =>
    plural([
      `The ${named("name")} in pictures`,
      `The ${named("name")} in pictures`,
    ]),
  return: "Return",
  galery: "Gallery",
  discover: "Discover",
  installment_from: "from {price}€/month",
  price_from: "from {price} €",
  or: "or",
  month: "month",
  first_rent: "1st rent of {price} €",
};
